import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", location.pathname);
    if (!sessionId) return navigate("/auth", { replace: true });
    api.post("/auth/google/session", { session_id: sessionId })
      .then((r) => { setUser(r.data); navigate("/account", { replace: true }); })
      .catch(() => navigate("/auth?error=google", { replace: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <div data-testid="auth-callback" className="min-h-screen bg-ivory" />;
}
